// extracted by mini-css-extract-plugin
export default {"BetaFeatureFeedbackPopover":"RXi4jFEQ6UolgV6cMrY6","BetaFeatureFeedbackPopover--force-absolute":"I2g6i9IsTXKZAB7oG1Gv"};